export const APP_DATE_FORMAT = 'yyyy-MM-dd';

export function toIso(date: Date | string | null | undefined): string | undefined {
  if (!date) return undefined;
  
  const dateObj = new Date(date);
  // Use local date components to avoid timezone shifts
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}T00:00:00.000Z`;
}

export function toLocalDate(dateValue: string | Date | null | undefined): Date | null {
  if (!dateValue) return null;
  
  // If it's already a Date object, return it
  if (dateValue instanceof Date) {
    return dateValue;
  }
  
  // Parse date string as local date to avoid timezone shifts
  const dateString = dateValue.toString();
  const dateParts = dateString.split('T')[0].split('-');
  if (dateParts.length === 3) {
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed
    const day = parseInt(dateParts[2], 10);
    return new Date(year, month, day);
  }
  
  return new Date(dateString);
}
